import React from "react";

interface PinState {
  // story: boolean;
  // event: boolean;
  site: boolean;
}

export const initialPinState: PinState = {
  // story: true,
  // event: true,
  site: true,
};

export const PinContext = React.createContext<
  [PinState, React.Dispatch<React.SetStateAction<PinState>>]
>([initialPinState, () => { }]);
